import React, { useEffect, useState } from 'react';
import { Field as Fieldmik, FieldArray, Formik } from 'formik';
import { Form as FormUi, Input, Button, Dropdown, Grid, Header, Table, Icon, Segment } from 'semantic-ui-react';
import Axios from 'axios';
import moment from 'moment';

import { MyInput, MyNormalInput } from '../formikInput/input';
import APP_CONSTANTS from '../../config/constants';
import ProductSKUDropdown from '../dropdowns/productSKUDropdown';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';



const AddAdditionalCharge = ({ editmode, billmode, poId, poReferenceNo, 
    masterState, vendorStateId, isGstApplicable, getVendorPurchaseOrder,
    formValues, updatePurchaseOrder, handleClose, setInitialize,
    viewmode, vendorData }) => {

    const [productData, setProductData] = useState([])
    const [purchaseOrderDetails, setPurchaseOrderDetails] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true)
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let data = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo,
                // "poId": poId,
                "searchString": poReferenceNo
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}purchase/purchaseorder/getPurchaseOrders`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setPurchaseOrderDetails(response.data.data).then(() => setIsLoading(false))
        }))
            .catch(error => console.log(error)).then(() => setIsLoading(false))
    }, [])

    const getProductData = childData => {
        console.log("Product Data", childData, billmode)
        setProductData(childData);
    }


    if(isLoading){
        return <LoadingPlaceholder />
    } else if (purchaseOrderDetails && purchaseOrderDetails.length > 0) {

    //ArrayHelper
    Array.prototype.sum = function (prop) {
        var total = 0
        for (var i = 0, _len = this.length; i < _len; i++) {
            total += this[i][prop]
        }
        return total
    }

    let psLineItems = []

    purchaseOrderDetails && purchaseOrderDetails[0].po_details.map((po, index) => {
        let temp = {}
        temp.productName = po.productId
        temp.productCode = po.psCode
        temp.startDate = po.startDate === "0000-00-00" ? "" : new Date(po.startDate)
        temp.endDate = po.endDate === "0000-00-00" ? ""  : new Date(po.endDate)
        temp.quantity = po.productQty
        temp.isAdditionalCharge = po.isAdditionalCharge
        temp.rate = po.productPrice
        temp.discount = po.discount
        temp.discountType = po.discountType
        temp.iGstPercent = Math.trunc(po.igstPercent)
        temp.iGst = ''
        temp.cGstPercent = Math.trunc(po.cgstPercent)
        temp.cGst = ''
        temp.sGstPercent = Math.trunc(po.sgstPercent)
        temp.sGst = ''
        temp.amount = ''

        psLineItems[index] = temp

    }) 

    const initialValues = {
        productDetails: psLineItems && psLineItems

    }


    const onSubmit = (values, onSubmitProps) => {
        const customerNumber = localStorage.getItem('customerNo');
        const userId = localStorage.getItem('userId');

        let psLineItems = [];
        values.productDetails.map((product, index) => {
            let temp = {}
            temp.psCode = product.productCode
            temp.psName = product.productName
            temp.startDate = product.startDate
            temp.endDate = product.endDate
            temp.psQty = product.quantity
            temp.psPrice = product.rate
            temp.psAmount = product.rate * product.quantity
            temp.igstPercent = product.iGstPercent
            temp.isAdditionalCharge = product.isAdditionalCharge
            temp.igstAmount = product.iGst
            temp.cgstPercent = product.cGstPercent
            temp.cgstAmount = product.cGst
            temp.sgstPercent = product.sGstPercent
            temp.sgstAmount = product.sGst
            temp.tdsCode = 9
            temp.discount = product.discount
            temp.finalDiscount = product.discount
            temp.discountType = product.discountType
            temp.taxableAmount = product.rate * product.quantity - product.discount
            temp.totalAmount = product.amount

            psLineItems[index] = temp
        });

        const updateAdditionalCharges = {
            customerNo: customerNumber,
            userId: userId,
            poReferenceNo: purchaseOrderDetails[0].poReferenceNo ,
            vendorCode: purchaseOrderDetails[0].vendorCode,
            branchCode: purchaseOrderDetails[0].branchCode,
            vendorBranchCode: purchaseOrderDetails[0].vendorBranchCode,
            vehicleNo: purchaseOrderDetails[0].vehicleNo,
            poQuantity: psLineItems.length,
            poAmount: values.finalAmount,
            poNumber: purchaseOrderDetails[0].poNumber,
            sgstAmount: psLineItems.sum("sgstAmount"),
            cgstAmount: psLineItems.sum("cgstAmount"),
            igstAmount: psLineItems.sum("igstAmount"),
            adjustment: values.adjustmentAmount,
            remarks: '',
            gstTaxType: '',
            poDate: moment(purchaseOrderDetails[0].poDate).format('DD-MM-YYYY'),
            tdsAmount: '',
            taxableAmount: psLineItems.sum("taxableAmount"),
            totalDiscount: psLineItems.sum("discount"),
            totalOrderAmt: values.finalAmount,
            psDetails: psLineItems,
        }

        console.log("Modal Submit Values", updateAdditionalCharges, formValues)
        updatePurchaseOrder(updateAdditionalCharges, handleClose).then(() => {
            setInitialize(true)
            setTimeout(() => {onSubmitProps.setSubmitting(false)} , 4000)

            const edit = true

            editmode ?

            getVendorPurchaseOrder(vendorData, edit).then(() => {
                setInitialize(false)
            })

            :

            getVendorPurchaseOrder(formValues.vendorName).then(() => {
                setInitialize(false)
            })
            
        });
    }

    return (
        <div className="ui form">
            <Formik 
                initialValues={initialValues}
                onSubmit={onSubmit}>

                    <FieldArray
                        name="productDetails">
                        {({ push, remove, replace, form }) => {

                            const { inititalValues, values, setFieldValue, isSubmitting, handleSubmit } = form
                            const { productDetails } = values


                            if (billmode == true) {
                                values.manualPoAddedTotal = parseFloat(productDetails.reduce((total, obj) => obj.amount + total, 0)).toFixed(2)
                                values.finalAmount = +values.activePoAddedTotal + +values.manualPoAddedTotal
                            }
                            else if (billmode == "view") {
                                console.log("IN IF", poId);
                                values.finalAmount = parseFloat(productDetails.reduce((total, obj) => obj.amount + total, 0)).toFixed(2)
                            }
                            else {
                                values.finalAmount = parseFloat(productDetails.reduce((total, obj) => obj.amount + total, 0)).toFixed(2)
                            }

                            let productSelectedArray = []

                            productDetails.map((product, index) => {
                                let temp = {}
                                temp.productName = product.productName

                                productSelectedArray[index] = temp
                            })

                            const handleUpdateProduct = (e, data, index, object) => {
  
                                const { setFieldValue } = form
    
                                let addedProductObject = productData.filter(e => {
                                    return e.psId === data.value
                                })
                        
                                setFieldValue(data.name, data.value).then(() => {
                                    replace(index, {
                                        productName: data.value,
                                        productCode: addedProductObject && addedProductObject[0] ? addedProductObject[0].psCode : "",
                                        hsnCode: addedProductObject && addedProductObject[0] ? addedProductObject[0].HSNCode : "",
                                        sacCode: addedProductObject && addedProductObject[0] ? addedProductObject[0].SACCode : "",
                                        quantity: object.quantity,
                                        discountType: object.discountType,
                                        discount: "",
                                        rate: addedProductObject && addedProductObject[0] ? addedProductObject[0].sellingPrice : "",
                                        iGstPercent: vendorStateId === masterState ? "" : addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage,
                                        cGstPercent: vendorStateId === masterState ? addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage/2 : "",
                                        sGstPercent: vendorStateId === masterState ? addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage/2 : "",
                                        
                                    })
    
                                    
                                })
                            console.log("Handle Pressed", e, data, index, object)    
                            }

                            console.log("Values ProductDetails", values, form)
                            return (
                                <>
                                    <Table unstackable size="large" compact="very" className="w3-small">
                                        <Table.Header>
                                            {console.log("values for state", masterState, vendorStateId, values)}
                                            <Table.Row>
                                                <Table.HeaderCell className="w3-white" colSpan="8">  <label className="labelName w3-text-blue">Product/Service Details</label></Table.HeaderCell>
                                            </Table.Row>
                                            <Table.Row >
                                                <Table.HeaderCell className="labelName p-bold-600">Product Details</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">HSN/SAC Code</Table.HeaderCell>
                                                {/* <Table.HeaderCell className="labelName p-bold-600">Start Date</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">End Date</Table.HeaderCell> */}
                                                <Table.HeaderCell className="labelName p-bold-600">Quantity</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Rate</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Discount</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">IGST%</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">IGST(₹)</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">CGST</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">CGST(₹)</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">SGST</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">SGST(₹)</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Amount</Table.HeaderCell>
                                                <Table.HeaderCell textAlign="right" className="labelName p-bold-600">Delete</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>

                                        <Table.Body>
                                            {productDetails.map((object, index) => {

                                                const discountOptions = [
                                                    { key: '1', text: '₹', value: '1' },
                                                    { key: '2', text: '%', value: '2' },
                                                ];


                                                let tempAmount = '';
                                                if (object.discount > 0 && object.discountType == 1) {
                                                    let finalRate = +object.rate * +object.quantity
                                                    console.log("Final Rate", finalRate, object.amount, object.rate)
                                                    tempAmount = +finalRate - +object.discount
                                                } else {
                                                    let finalRate = +object.rate * +object.quantity
                                                    tempAmount = +finalRate - (+finalRate * +object.discount / 100)
                                                    console.log("Final Rate", finalRate, object.discount, object.discountType)
                                                }

                                                // if (object.productName) {
                                                //     let addedProductObject = productData.filter(e => {
                                                //         return e.psId === object.productName
                                                //     })

                                                //     console.log("addedProduct =====>", addedProductObject, productData)
                                                //     if (addedProductObject && productData.length > 0) {

                                                //         if(object.rate.length === 0) {
                                                //             object.rate = addedProductObject ? +addedProductObject[0].sellingPrice : '';
                                                //         }

                                                //         object.hsnCode = addedProductObject && addedProductObject.length > 0 ? addedProductObject[0].HSNCode : '';
                                                //         object.sacCode = addedProductObject && addedProductObject.length > 0 ? addedProductObject[0].SACCode : '';

                                                       

                                                //         if(isGstApplicable){
                                                            
                                                //             if(vendorStateId === masterState){
                                                                
                                                //                 object.iGstPercent = addedProductObject.length > 0 && addedProductObject[0].gstPercentage
                                                //                 console.log("VendorMasterBranch", vendorStateId, masterState)
           
                                                //             } else {
                                                //                 console.log("VendorMasterBranch", vendorStateId, masterState)
                                                //                 object.cGstPercent = addedProductObject.length > 0 && addedProductObject[0].gstPercentage / 2
                                                //                 object.sGstPercent = addedProductObject.length > 0 && addedProductObject[0].gstPercentage / 2

                                                //             }
                                                //         } else {
                                                //             object.cGstPercent = 0
                                                //             object.sGstPercent = 0
                                                //             object.iGstPercent = 0
                                                //         }

                                                //         object.productCode = addedProductObject && addedProductObject.length > 0 ? addedProductObject[0].psCode : ''

                                                //     } else if (addedProductObject && productData.length > 0) {

                                                //         object.productCode = addedProductObject[0].psCode
                                                //         console.log("Product Code ", object.productCode)
                                                //     }
                                                // }

                                                object.iGst = +object.iGstPercent / 100 * +tempAmount
                                                object.cGst = +object.cGstPercent / 100 * +tempAmount
                                                object.sGst = +object.sGstPercent / 100 * +tempAmount

                                                object.amount = +tempAmount + +object.iGst + +object.cGst + +object.sGst

                                                console.log("OBject.Amount", object.amount)

                                                values.finalAmount = parseFloat(productDetails.reduce((total, obj) => obj.amount + total, 0)).toFixed(2)


                                                return (
                                                    <Table.Row verticalAlign="middle" key={index} >
                                                        <React.Fragment>
                                                            <Table.Cell style={{backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : ""}}>
                                                                    <Fieldmik
                                                                        component={ProductSKUDropdown}
                                                                        getProductData={getProductData}
                                                                        productIndex={index}
                                                                        productObject={object}
                                                                        handleUpdateProduct={handleUpdateProduct}
                                                                        placeholder="Product Name"
                                                                        name={`productDetails[${index}].productName`}
                                                                        style={{ width: '240px'}}
                                                                        value={object.productName ? object.productName : ''}
                                                                        productSelectedArray={productSelectedArray}
                                                                        selectedProductEdit={object.productName}
                                                                        disabled={viewmode}
                                                                    />
                                                            </Table.Cell>
                                                            {/* <Table.Cell style={{ minWidth: '124px' }}>
                                                                <DateData
                                                                    name={`productDetails[${index}].startDate`}
                                                                    autoComplete="off"
                                                                    popperClassName="dateTime"
                                                                    dateFormat="dd-MM-yyyy"
                                                                    placeholderText="Start Date"
                                                                    selected={productDetails[index].startDate}
                                                                    selectsStart
                                                                    startDate={productDetails[index].startDate}
                                                                    maxDate={productDetails[index]['endDate'] ? productDetails[index]['endDate'] : ''}
                                                                    endDate={productDetails[index]['endDate']}
                                                                    timeIntervals={5}
                                                                    customInput={<FormUi.Input error={productDetails[index].startDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                                />
                                                            </Table.Cell>
                                                            <Table.Cell style={{ minWidth: '124px' }}>
                                                                <DateData
                                                                    name={`productDetails[${index}].endDate`}
                                                                    autoComplete="off"
                                                                    popperClassName="dateTime"
                                                                    dateFormat="dd-MM-yyyy"
                                                                    placeholderText="End Date"
                                                                    selected={productDetails[index].endDate}
                                                                    selectsStart
                                                                    startDate={productDetails[index].endDate}
                                                                    endDate={productDetails[index]['startDate']}
                                                                    minDate={productDetails[index]['startDate'] ? productDetails[index]['startDate'] : ''}
                                                                    timeIntervals={5}
                                                                    customInput={<FormUi.Input error={productDetails[index].endDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                                />
                                                            </Table.Cell> */}
                                                            <Table.Cell width={2} style={{ backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : ""}}>
                                                                {object.hsnCode || object.sacCode ? `${object.hsnCode, object.sacCode}` : ''}
                                                            </Table.Cell>
                                                            {console.log("HSNSACCode", object.sacCode, object.hsnCode)}
                                                            <Table.Cell style={{ minWidth: '80px', backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : "" }}>
                                                                <Fieldmik
                                                                    readOnly={viewmode}
                                                                    component={MyNormalInput}
                                                                    type="number"
                                                                    value={object.quantity === 0 ? '' : object.quantity}
                                                                    min="1"
                                                                    autoComplete="off"
                                                                    name={`productDetails[${index}].quantity`}
                                                                    size="small"
                                                                    style={{ width: '180px' }}
                                                                    // disabled={object.isAdditionalCharge === 0 ? true : false}
                                                                />
                                                            </Table.Cell>
                                                            <Table.Cell style={{ minWidth: '90px', backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : "" }}>
                                                                <Fieldmik
                                                                    readOnly={viewmode}
                                                                    component={MyNormalInput}
                                                                    type="number"
                                                                    min="0"
                                                                    value={object.rate === 0 ? 0 : object.rate}
                                                                    autoComplete="off"
                                                                    name={`productDetails[${index}].rate`}
                                                                    size="small"
                                                                    style={{ width: '180px', backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : "",  }}
                                                                    // disabled={object.isAdditionalCharge === 0 ? true : false}
                                                                />
                                                            </Table.Cell>
                                                            <Table.Cell style={{ minWidth: '124px', backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : "" }}>                 
                                                                <Fieldmik  
                                                                    readOnly={viewmode}
                                                                    style={{ width: '60%' }} 
                                                                    type="number" 
                                                                    component={MyNormalInput} 
                                                                    value={object.discount === 0 ? 0 : object.discount} 
                                                                    name={`productDetails[${index}].discount`} 
                                                                    size="small"
                                                                    label={<Dropdown disabled={viewmode} placeholder={object.discountType === 2 ? '%' : "₹"} 
                                                                    options={discountOptions} defaultValue={object.discountType}
                                                                    onChange={(value, data) => object.discountType = data.value} />} 
                                                                    labelPosition="right" className="tableinput" 
                                                                />
                                                            </Table.Cell>
                                                            <Table.Cell style={{ backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : "" }}>
                                                                {object.iGstPercent ? `${object.iGstPercent}%` : '0%'}
                                                            </Table.Cell>
                                                            <Table.Cell style={{ backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : "" }}>
                                                                {object.iGst ? object.iGst.toFixed(2) : '0'}
                                                            </Table.Cell>
                                                            <Table.Cell style={{ backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : "" }}>
                                                                {object.cGstPercent ? `${object.cGstPercent}%` : '0%'}
                                                            </Table.Cell>
                                                            <Table.Cell style={{ backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : "" }}>
                                                                {object.cGst ? object.cGst.toFixed(2) : '0'}
                                                            </Table.Cell>
                                                            <Table.Cell style={{ backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : "" }}>
                                                                {object.sGstPercent ? `${object.sGstPercent}%` : '0%'}
                                                            </Table.Cell>
                                                            <Table.Cell style={{ backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : "" }}>
                                                                {object.sGst ? object.sGst.toFixed(2) : '0'}
                                                            </Table.Cell>
                                                            <Table.Cell style={{ backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : "" }}>
                                                                {object.amount ? object.amount.toFixed(2) : '0'}
                                                            </Table.Cell>
                                                            <Table.Cell 
                                                                hidden={index > 0 ? false : true} 
                                                                textAlign="right"
                                                                style={{ backgroundColor: object.isAdditionalCharge === 1 ? "#D9EAFC" : "" }}
                                                            >
                                                                {viewmode ? "" : 
                                                                    <Button onClick={() => remove(index)} type="button" basic size="mini" icon>
                                                                        <Icon className="overhere" color="red" name="trash" />
                                                                    </Button>  
                                                                }                                
                                                            </Table.Cell>
                                                        </React.Fragment>

                                                    </Table.Row>
                                                )
                                            }
                                            )}
                                        </Table.Body>
                                    </Table>
                                    <Grid columns={3}>
                                        <Grid.Row className="p-2">
                                            {viewmode ? <Grid.Column width={10} /> : 
                                                <Grid.Column width={10}>
                                                    <Button className="ml-2" type="button" onClick={() => push({ productName: '', startDate: '', endDate: '', hsnCode: '', sacCode: '', isAdditionalCharge: 0, quantity: '', rate: '', discount: '', discountType: '1', iGstPercent: '', iGst: '', cGstPercent: '', cGst: '', sGstPercent: '', sGst: '', amount: '' })} size="mini" basic color="blue">
                                                        + Add Product
                                                        </Button>
                                                </Grid.Column>
                                            }
                                            <Grid.Column>
                                                {/* {billmode ?
                                                    <>
                                                        <Grid.Row>
                                                            <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">New PO Total</Header>
                                                            <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.manualPoAddedTotal}</Header>
                                                        </Grid.Row>
                                                        <Grid.Row>
                                                            <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Active PO Total</Header>
                                                            <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.activePoAddedTotal}</Header>
                                                        </Grid.Row>
                                                    </>
                                                    :
                                                    ""
                                                } */}
                                                <Grid.Row>
                                                    <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Total</Header>
                                                    <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.finalAmount ? values.finalAmount : ''}</Header>
                                                </Grid.Row>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                    {viewmode ? "" :
                                        <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
                                    }
                                </>
                            )
                        }}

                    </FieldArray>

            </Formik>
        </div>
    )
} else {
    return (
        <Segment>No Record(s) Found</Segment>
    )
}

}

export default AddAdditionalCharge










